import React from 'react';
import { env } from 'core/utils/env';
import { Button, QuestionCircleOutlined } from '../ui';

export function Help() {
  return (
    <Button icon={<QuestionCircleOutlined />} type="link" href={env.DOCS_URL} target="blank" />
  );
}
